import React, { Component } from "react";
import { connect } from "react-redux";
import "../AuthContainer/AuthContainer.scss";
import ReactGA from "react-ga";
import MainImage from "../AuthContainer/main-image1.png";
import { Switch, Link, Route, Redirect } from "react-router-dom";

import { ReactComponent as RadarrLogo } from "../../assets/radarr-logo-green.svg";

import Scrollbars from "react-custom-scrollbars";
// import CompanyDetailsForms from "./CompanyDetailsForms";
// import CompanyDetailsForms from "./UserProfileSetup/CompanyDetailsForm/CompanyDetailsForms";
import SubscriptionPage from "./SubscriptionPage";
import SubscriptionPageSuccess from "./SubscriptionPageSuccess";
import SubscriptionPageError from "./SubscriptionPageError";

class SignUpSteps extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="auth-container">
                <div className="auth-navbar">
                    <RadarrLogo />
                    <Link to="/signout">
                        <div className="navbar-button">Sign Out</div>
                    </Link>
                </div>
                <div className="auth-contents">
                    <div className="auth__left-wrap">
                        <div className="main-text">
                            <p>A powerful social media intelligence tool</p>
                            <p>that helps you listen, monitor and track online conversations easily.</p>
                        </div>
                        <div className="main-image">
                            <img src={MainImage} />
                        </div>
                        <p style={{ color: "#fff", paddingLeft: "30px" }}>Radarr helps 1000+ brands globally get actionable insights</p>
                        <div className="company-logos">
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/discovery-networks-logo.png" alt="Discovery" />
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/twitter-logo.png" alt="X" />
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/glico-logo.png" alt="Glico" />
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/quantum-logo.png" alt="Quantum" />
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/toyota-logo-1.png" alt="Toyota" />
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/hong-leong-bank-logo.png" alt="Toyota" />
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/mapletree-logo.png" alt="Mapletree" />
                        </div>
                    </div>
                    <div className="auth-right">
                        <Scrollbars renderView={(props) => <div {...props} className="signsteps-scrollbar-view" />}>
                            <Switch>
                                <Route path="/subscription/success" component={SubscriptionPageSuccess} />
                                <Route path="/subscription/error" component={SubscriptionPageError} />
                                {/* {this.props.company.is_profile_setup === 1 && this.props.packageObj.package_code !== "free" && <Redirect to="/home" />} */}
                                {/* <Route path="/company-details" render={(props) => <CompanyDetailsForms {...props} company={this.props.company} />} /> need to change this both lines*/}
                                <Route path="/subscription" exact component={SubscriptionPage} />
                            </Switch>
                        </Scrollbars>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    company: state.globalReducer.company,
    packageObj: state.globalReducer.packageObj,
    otpSent: state.authReducer.otpSent,
});

export default connect(mapStateToProps)(SignUpSteps);
